import React, { useEffect } from 'react';
import { Button, Input, Checkbox, Select, Textarea, Box, Heading, FormControl, FormLabel, Flex, VStack, Text, Grid, GridItem } from '@chakra-ui/react';
import { AttachmentIcon } from '@chakra-ui/icons';
import { useState } from 'react';
import { UnorderedList, ListItem } from '@chakra-ui/react';
import toast from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';

import Layout from '../Layout/Layout.js'

import {
	sourceTypeInputPlaceholderLinkToPdfPage,
	submitButtonText,
	submitWaitingText,
	urlInputIdLinkToPdfPage,
	urlInputPlaceholderLinkToPdfPage,
} from '../homeDynamicTexts.js';
import { selectToken, selectDataArchive, selectUserName } from '../Redux/Reducer/index.js';
import { archiveTraceSubmit} from '../Redux/Thunk/ArchiveUpload/index.js';
import categoryOfData2 from '../Components/categoryOfData2';

export default function ArchiveTracePage() {
	const dispatch = useDispatch();

	const token = useSelector(state => selectToken(state));
	const userName = useSelector(state => selectUserName(state));
	const data = useSelector(state => selectDataArchive(state));

	const [uploadFlag, setUploadFlag] = useState(false);

	// file upload 
	// for multiple file system
	const [selectedFiles, setSelectedFiles] = useState(null);
	const [previews, setPreviews] = useState([]);
	const [error, setError] = useState('');
	useEffect(() => {
		// Cleanup the object URLs when component unmounts or previews change
		return () => {
			previews.forEach(file => URL.revokeObjectURL(file.url));
		};
	}, [previews]);
	const handleFileChange = (event) => {
		const files = Array.from(event.target.files);

		const maxSize = 2 * 1024 * 1024 * 1024; // 2GB in bytes

		const validFiles = [];
		const filePreviews = [];
		files.forEach(file => {
			if (file.size > maxSize) {
				setError(`File "${file.name}" exceeds the 2GB size limit.`);
			} else {
				validFiles.push(file);
				const fileURL = URL.createObjectURL(file);
				filePreviews.push({ name: file.name, type: file.type, url: fileURL });
			}
		});
		if (validFiles.length > 0) {
			setSelectedFiles(validFiles);
			setPreviews(filePreviews);
			setError(''); // Clear any previous errors
		}
	};


	const handleSubmit = event => {
		event.preventDefault();

		// if (selectedCategoriesOptions.length > 0) {
		if (selectedFiles) {     // for multiple file system

			const formData = new FormData();
			formData.append('tag', categoryOfData2.tags[0]);
			// for multiple file system
			selectedFiles.forEach((file) => {
				formData.append('files', file); // Append each file with a 'files[]' key
			});

			dispatch(archiveTraceSubmit(formData, token));
			setUploadFlag(true);
		}
		else {
			toast.error('Please select of at least one file to send.');
		}
	};

	useEffect(() => {
		if (data.success) {
			toast.success("The files have been uploaded.");
			setUploadFlag(false);
		}
		if (data.error.message) {
			toast.error(data.error.message);
			setUploadFlag(false);
		}
	}, [data.error.message, data.success, dispatch]);

	return (
		<Layout>
			<Box
				px={{ base: '2', md: '4', }}
				py={{ base: '4', md: '8' }}
				maxW={{ base: "98vw", md: "80vw" }} mx="auto"
			>
				<Heading
					as="h1"
					textAlign="left"
					size="xl"
					color="gray.800"
					mb={6}
					fontFamily="Montserrat, sans-serif"
				>
					Upload Traces
				</Heading>

				<Box bg="white" shadow="md" rounded="lg" p={6} mb={8}>
					<form onSubmit={handleSubmit}>
						<VStack spacing={6} align="stretch">
							<FormControl>
								<FormLabel htmlFor="file-upload">Upload File</FormLabel>
								<Box
									border="2px"
									borderColor="gray.300"
									borderStyle="dashed"
									rounded="md"
									p={5}
									textAlign="center"
								>
									<AttachmentIcon w={8} h={8} color="gray.400" />
									<Flex mt={2} justify="center" align="center">
										<label htmlFor="file-upload">
											<Text
												as="span"
												color="red.600"
												_hover={{ cursor: 'pointer', color: 'red.500' }}
												textDecoration="underline"
											>
												Upload a file
											</Text>
										</label>
										<Text mx={2}>or drag and drop</Text>
									</Flex>
									<Input id="file-upload" type="file" display="none" onChange={handleFileChange} />
									<Input
										type="file"
										onChange={handleFileChange}
										multiple   // for multiple file system
										accept="application/pdf,video/*, audio/*, image/*, application/msword"
										variant='filled'
									/>
									<Text fontSize="sm" color="gray.500">PDF, DOC, DOCX up to 2GB</Text>

									{error && <p style={{ color: 'red' }}>{error}</p>}

									{/* // for multiple file system */}
									{/* <Stack gap={[2, 5]} direction={['column', 'column', 'row']}> */}
									<Grid
										templateRows='repeat(1, 1fr)'
										templateColumns='repeat(4, 1fr)'
									>
										{previews.map((file, index) => (
											<GridItem
												colSpan={[4, 2, 1]}
												p='2'
												key={index}
											>
												{
													file.type.includes('pdf') ? (
														<Box h={['200px',]}>
															<iframe
																src={file.url}
																title={file.name}
																width="100%"
																height="100%"
															></iframe>
														</Box>
													) : file.type.includes('image') ? (
														<Box w={'100%'} mx={'auto'}>
															<img
																src={file.url}
																alt={file.name}
																style={{ maxWidth: '100%', height: 'auto' }}
															/>
														</Box>
													) : (
														<video
															controls
															width="500"
															src={file.url}
														>
															Your browser does not support the video tag.
														</video>
													)
												}
											</GridItem>
										))}
									</Grid>
								</Box>
							</FormControl>

							<Button
								size="lg"
								bg={"red.500"}
								color={"white"}
								_hover={{ bg: "red.900" }}
								px={4}
								py={1}
								borderRadius={'lg'}
								isDisabled={uploadFlag}
								type='submit'
								onClick={(event) => {
									handleSubmit(event);
								}}
							>
								{uploadFlag ? `${submitWaitingText}` : `${submitButtonText}`}
							</Button>
						</VStack>
					</form>
				</Box>
			</Box>
		</Layout>
	);
}
